import { createAsyncThunk } from '@reduxjs/toolkit'
import type { AxiosError } from 'axios'

import { ValidationErrors } from 'store/types'

import { getAxiosInstance } from 'services/api'

import { useDispatch } from 'react-redux'
import { Notification } from 'types/app'

const api = getAxiosInstance()

export const getAllNotifications = createAsyncThunk<
  Notification[],
  void,
  { rejectValue: ValidationErrors }
>('notifications/getAll', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/notifications')
    return data
  } catch (err) {
    const error = err as AxiosError<ValidationErrors>

    if (!error.response) {
      throw err
    }

    return rejectWithValue(error.response.data)
  }
})

export const markNotificationAsRead = createAsyncThunk<
  Notification,
  string,
  { rejectValue: ValidationErrors }
>('notifications/markAsRead', async (id, { rejectWithValue }) => {
  try {
    const { data } = await api.put(`/notification/mark/${id}`)
    return data
  } catch (err) {
    const error = err as AxiosError<ValidationErrors>

    if (!error.response) {
      throw err
    }

    return rejectWithValue(error.response.data)
  }
})

export const clearAllNotifications = createAsyncThunk<
  void,
  void,
  { rejectValue: ValidationErrors }
>('notifications/clearAll', async (_, { rejectWithValue }) => {
  try {
    await api.delete('/notifications/clear')
  } catch (err) {
    const error = err as AxiosError<ValidationErrors>

    if (!error.response) {
      throw err
    }

    return rejectWithValue(error.response.data)
  }
})

export const markAllNotificationsAsRead = createAsyncThunk<
  { notifications: Notification[]; count: number },
  void,
  { rejectValue: ValidationErrors }
>('notifications/markAllAsRead', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.put('/notifications/mark-all-read')
    return data
  } catch (err) {
    const error = err as AxiosError<ValidationErrors>

    if (!error.response) {
      throw err
    }

    return rejectWithValue(error.response.data)
  }
})
